import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Kemper from "./pages/Kemper";
import Tonex from "./pages/Tonex";
import Nam from "./pages/Nam";
import IR from "./pages/IR";
import Details from "./pages/Details";
import Imprint from "./pages/Imprint";
import Privacy from "./pages/Privacy";
import Plugin from "./pages/Plugin";
import PWCskinV1 from "./pages/PWCskinV1";
import PWCskinV2 from "./pages/PWCskinV2";
import NotFound from "./pages/NotFound";

import ScrollToTop from "./components/ScrollToTop"; // Import the component

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="bg-gray-900 min-h-screen overflow-x-hidden">
        <div id="main" className="flex flex-col min-h-screen font-roboto overflow-x-hidden max-w-full">
          <Navigation />

          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/kemper" element={<Kemper />} />
              <Route path="/tonex" element={<Tonex />} />
              <Route path="/nam" element={<Nam />} />
              <Route path="/ir" element={<IR />} />
              <Route path="/cab-ir" element={<IR />} />
              <Route path="/reverb-ir" element={<IR />} />
              <Route path="/plugins" element={<Plugin />} />
              <Route path="/plugins/pwcskinv1" element={<PWCskinV1 />} />
              <Route path="/plugins/pwcskinv2" element={<PWCskinV2 />} />
              <Route path="/details/:id" element={<Details />} />
              <Route path="/imprint" element={<Imprint />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </div>
    </Router>
  );
};

export default App;
